/**
 * PWA Prompt Component
 * 
 * Auto-reloads when PWA updates are available
 * Requirements: 11.6
 */

import { useEffect } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';

export function PWAPrompt() {
  const {
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegistered(r) {
      console.log('SW Registered:', r);
    },
    onRegisterError(error) {
      console.error('SW registration error:', error);
    },
  });

  useEffect(() => {
    // Auto-reload when new content is available
    if (needRefresh) {
      console.log('New content available, auto-reloading...');
      updateServiceWorker(true).then(() => {
        // Force a hard reload after service worker update
        window.location.reload();
      });
    }
  }, [needRefresh, updateServiceWorker]);

  // No UI needed - auto-reload happens silently
  return null;
}
